/*@flow*/
import type { Metric, State$WidgetForm, UnsavedMetric } from './types';
import * as t from 'lib/t';

const formulaRegExp = /^(.*?)(\{.+\})(.*)$/;
const lineBreakRegExp = /(\r\n|\n|\r)/gm;

export const metricToForm = (o: Metric): State$WidgetForm => {
  const { analysis, valueFormula, dataview, ...rest } = o;
  t.invariant(analysis, t.Object, 'Analysis is missing.');
  return {
    ...rest,
    table: analysis.table,
    analysisId: analysis.id,
    op: dataview.operation,
    column: dataview.column,
    formula: valueFormula || '',
    custom: true,
  };
};

export const formToMetric = (o: State$WidgetForm): $Exact<UnsavedMetric> => {
  let { formula, op, column, analysisId, table, ...rest } = o;
  const res = formula
    ? formula.replace(lineBreakRegExp, '').match(formulaRegExp) || []
    : [];
  t.invariant(res, t.Array, 'Formula is not valid.');

  if (op === 'count') {
    column = 'cartodb_id';
  }
  const [_all, prefix, value, postfix] = res; // eslint-disable-line no-unused-vars
  const sql = `SELECT * FROM ${table}`;

  const dataview = {
    column,
    operation: op,
  };

  return (({
    ...rest,
    analysis: { id: analysisId, table, sql },
    dataview,
    prefix,
    postfix,
    valueFormula: value,
    custom: true,
  }: any): $Exact<UnsavedMetric>);
};
